import React from 'react';
import { Input } from 'antd';
import { useFormContext, Controller } from 'react-hook-form';

interface FormFieldProps {
  name: string;
  label: string;
  type?: string;
  placeholder?: string;
  required?: boolean;
  disabled?: boolean;
  textarea?: boolean;
  onValueChange?: (value: string | number) => void;
}

export default function FormField({ name, label, type = 'text', placeholder, required, disabled, textarea, onValueChange }: FormFieldProps) {
  const { control, formState: { errors } } = useFormContext();

  const error = name.split('.').reduce((obj: any, key) => obj?.[key], errors);
  const errorMsg = error?.message as string | undefined;

  return (
    <div className="mb-5">
      <label className="block text-sm font-medium text-neutral-600 mb-1.5">
        {label} {required && <span className="text-red-500">*</span>}
      </label>
      <Controller
        name={name}
        control={control}
        render={({ field }) => {
          const handleChange = (e: React.ChangeEvent<HTMLInputElement | HTMLTextAreaElement>) => {
            const val = type === 'number' ? (e.target.value === '' ? '' : Number(e.target.value)) : e.target.value;
            field.onChange(val);
            onValueChange?.(val);
          };
          if (textarea) {
            return (
              <Input.TextArea
                {...field}
                value={field.value ?? ''}
                onChange={handleChange}
                placeholder={placeholder}
                disabled={disabled}
                status={errorMsg ? 'error' : undefined}
                rows={3}
              />
            );
          }
          return (
            <Input
              {...field}
              value={field.value ?? ''}
              onChange={handleChange}
              type={type}
              placeholder={placeholder}
              disabled={disabled}
              status={errorMsg ? 'error' : undefined}
            />
          );
        }}
      />
      {errorMsg && <p className="text-red-500 text-xs mt-1">{errorMsg}</p>}
    </div>
  );
}
